import React from "react";
import { Link } from "react-router-dom";

const CarouselEmptyState = ({ type = "default" }) => {
  const emptyStates = {
    popular: {
      title: "No Popular Properties Yet",
      message:
        "Be the first to list a property that catches everyone's attention!",
      cta: "List Your Property",
      link: "/residentialAdd",
    },
    recent: {
      title: "No Recent Listings",
      message: "Stay tuned! New properties are added daily by our community.",
      cta: "Browse All Properties",
      link: "/active",
    },
    sold: {
      title: "No Recent Sales",
      message: "Check back soon to see successful transactions in your area!",
      cta: "View Active Listings",
      link: "/active",
    },
    leased: {
      title: "No Recent Leases",
      message: "Looking to lease? Check our active rental properties!",
      cta: "View Rentals",
      link: "/active",
    },
    default: {
      title: "No Properties Available",
      message:
        "We're working on bringing you the best properties in your area.",
      cta: "Explore",
      link: "/",
    },
  };

  const state = emptyStates[type] || emptyStates.default;

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="text-center max-w-md">
        <div className="text-6xl mb-4">{state.icon}</div>
        <h3 className="text-2xl font-bold text-gray-800 mb-3">{state.title}</h3>
        <p className="text-gray-600 mb-6">{state.message}</p>
        <Link
          to={state.link}
          className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-lg transition-all transform hover:scale-105 shadow-md"
        >
          {state.cta}
        </Link>
      </div>
    </div>
  );
};

export default CarouselEmptyState;
